import firebase from "firebase";
import api from '../api/api.js'

const md5 = require('js-md5');
const encrypt = (userId, password) => md5(userId + password)

export default {
  namespaced: true,

  state: {
    errMsg: ''
  },

  getters: {
    errMsg(state) {
      return state.errMsg
    }
  },

  mutations: {
    login(state, { userId, clientId }) {
      state.errMsg = ''
      sessionStorage.userId = userId
      sessionStorage.clientId = clientId.toUpperCase()
    },

    logout(state) {
      state.errMsg = ''
      delete sessionStorage.userId
      delete sessionStorage.clientId
      firebase.auth().signOut()
    },

    errMsg(state, param) {
      state.errMsg = param
    }
  },

  actions: {
    /**
     * ログイン
     * パスワードはMD5でハッシュ化
     */
    login({ commit }, payload) {
      commit('errMsg', '')

      // どちらかが未入力ならAPI投げない
      if (payload.userId !== '' && payload.password !== '') {
        const data = {
          user_id: payload.userId,
          password: encrypt(payload.userId, payload.password),
          service: 'sales_management'
        }

        return api.post('/api/v2/login', data)
          .then((res) => {
            const data = res.data
            if (data.status === 200) {
              firebase.auth().signInWithCustomToken(data.token)
                .then(function(result) {
                  commit('login', { userId: payload.userId, clientId: data.client_id })
                })
                .catch(function(error) {
                    commit('errMsg', error.message)
                  }
                )
            } else {
              commit('errMsg', data.message)
            }
          })
      } else {
        commit('errMsg', 'ユーザIDまたはパスワードが空白です')
      }
    },

    /**
     * ログアウト
     */
    logout({ commit }, payload) {
      commit('logout')
    },

    /**
     * パスワード変更
     */
    changePassword({ commit }, payload) {
      commit('errMsg', '')
      if (payload.password === '') {
        commit('errMsg', 'パスワードを入力してください')
        return
      } else if (payload.newPassword.length < 8) {
        commit('errMsg', 'パスワードは8文字以上にしてください')
        return
      } else if (payload.newPassword !== payload.confirmPassword) {
        commit('errMsg', '確認用パスワードが一致していません')
        return
      }
      const data = {
        user_id: payload.userId,
        password: encrypt(payload.userId, payload.password),
        new_password: encrypt(payload.userId, payload.newPassword),
      }
      return api.post('/api/v2/setting/account/password', data)
        .then((res) => {
            const data = res.data
            if (data.status === 200) {
              return res.data
            } else {
              commit('errMsg', data.message)
            }
          }
        )
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/module/auth.js